<template>
  <vx-card title="Bestellungen nach Adresse">
    <p v-if="meta && meta.totalAddresses > 0" class="text-xs text-grey mb-2">
      {{ meta.geocoded.toLocaleString("de-DE") }} /
      {{ meta.totalAddresses.toLocaleString("de-DE") }} Adressen geocodiert
      <span v-if="meta.geocoded < meta.totalAddresses">
        — Rest wird im Hintergrund geladen (bei jedem Seitenbesuch kommen mehr
        dazu)</span
      >
    </p>
    <p v-else-if="!locations.length" class="text-xs text-grey mb-2">
      Adress-Daten werden erstmalig aufgebaut — bitte Seite in ein paar Minuten
      neu laden
    </p>
    <div ref="map" style="height: 500px; border-radius: 6px"></div>
  </vx-card>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: "AnalyticsOrderHeatmap",
  data() {
    return {
      map: null,
      circleLayer: null,
    };
  },
  computed: {
    addressMapResponse() {
      return this.$store.state.analytics.addressMap;
    },
    locations() {
      return this.addressMapResponse ? this.addressMapResponse.data : [];
    },
    meta() {
      return this.addressMapResponse ? this.addressMapResponse.meta : null;
    },
  },
  watch: {
    locations() {
      this.buildMap();
    },
  },
  mounted() {
    this.initMap();
    if (this.locations && this.locations.length) {
      this.buildMap();
    }
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },
  methods: {
    initMap() {
      this.map = L.map(this.$refs.map, {
        zoomControl: false,
      }).setView([51.24, 6.78], 12);

      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 19,
      }).addTo(this.map);

      L.control.zoom({ position: "topright" }).addTo(this.map);
    },
    buildMap() {
      if (!this.locations || this.locations.length === 0) return;

      if (this.circleLayer) this.map.removeLayer(this.circleLayer);
      this.circleLayer = L.layerGroup().addTo(this.map);

      const maxOrders = Math.max(...this.locations.map((l) => l.orders));

      this.locations.forEach((loc) => {
        const ratio = loc.orders / maxOrders;
        const radius = 3 + Math.sqrt(ratio) * 12;

        const circle = L.circleMarker([loc.lat, loc.lng], {
          radius: radius,
          color: "#C41E2A",
          weight: 0.5,
          fillColor: "#C41E2A",
          fillOpacity: 0.2 + ratio * 0.5,
        });

        circle.bindTooltip(
          `<div style="font-size: 13px; line-height: 1.5;">` +
            `<strong>${loc.street} ${loc.streetNumber || ""}</strong><br>` +
            `${loc.zipCode} ${(loc.city || "").trim()}<br>` +
            `${loc.orders} Bestellungen<br>` +
            `${loc.revenue.toLocaleString("de-DE", {
              minimumFractionDigits: 2,
            })} €` +
            `</div>`,
          { direction: "top", className: "map-tooltip" },
        );

        circle.addTo(this.circleLayer);
      });

      // Laden-Marker (Münsterstraße 106, 40476 Düsseldorf)
      const shopIcon = L.divIcon({
        html: `<div style="
          background: #2563eb;
          width: 18px; height: 18px;
          border-radius: 50%;
          border: 3px solid #fff;
          box-shadow: 0 2px 6px rgba(0,0,0,0.4);
        "></div>`,
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        className: "",
      });
      L.marker([51.2490554, 6.7893279], { icon: shopIcon })
        .bindTooltip(
          `<div style="font-size: 13px; line-height: 1.5;">` +
            `<strong>Palace of Kebap</strong><br>` +
            `Münsterstraße 106, 40476 Düsseldorf</div>`,
          { direction: "top", className: "map-tooltip" },
        )
        .addTo(this.circleLayer);

      const bounds = L.latLngBounds(this.locations.map((l) => [l.lat, l.lng]));
      this.map.fitBounds(bounds, { padding: [40, 40] });
    },
  },
};
</script>

<style>
.map-tooltip {
  background: rgba(30, 30, 30, 0.95) !important;
  color: #fff !important;
  border: 1px solid #c41e2a !important;
  border-radius: 6px !important;
  padding: 6px 10px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;
}
.map-tooltip::before {
  border-top-color: #c41e2a !important;
}
</style>
